// extracted by mini-css-extract-plugin
export default {"restartBtn":"style_restartBtn__jdTMC"};